import {   StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("rm_budget")
export class RmBudgetEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"id"
    }) 
    id: number;

    
    @Column('varchar',{
        name:'count',
        nullable:false
    })
    count:string
 
    @Column('int',{
        name:'quantity',
        nullable:false
    })
    quantity:number

    @Column('int',{
        name:'procurement_manager_id',
        nullable:false
    })
    procurementManagerId:number

    @Column('varchar',{
        name:'month',
        nullable:false,
        length:50
    })
    month:string

    @Column('varchar',{
        name:'year',
        nullable:false,
        length:50
    })
    year:string

   
    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
    
}